module.exports = __webpack_public_path__ + "static/media/DSC_0189-2.07a4a08f.jpg";